import { useMutation } from '@tanstack/react-query';
import supabase from 'sdk/api';

const addBillingAddress = async (newAddress: any, userId) => {
    const { data: updateData, error: updateError } = await supabase
        .from('user_shippings')
        .insert({
            city: newAddress?.city,
            street: newAddress?.street,
            apartment: newAddress?.apartment,
            zip_code: newAddress?.zip_code,
            state: newAddress?.state,
            country: newAddress?.country,
            user: userId
        })

    if (updateError) {
        throw new Error(updateError.message);
    }

    return updateData;
};

export default function useAddShippingAddress() {
    return useMutation(({ newAddress, userId }: { newAddress: any, userId }) => addBillingAddress(newAddress, userId), {
        onSuccess: async (data) => data,
    });
}
